import { createSlice } from '@reduxjs/toolkit';
import { CollectionSequenceWithUser } from '@dill/dill-shared';
import {
  getSupplierCollectionSequencesExtraReducer,
  createCollectionSequenceExtraReducer,
  updateCollectionSequenceExtraReducer,
  deleteCollectionSequenceExtraReducer,
} from '../reducers/collectionSequenceReducers';

export interface CollectionSequenceInitialState {
  loadingList: string[];
  error: string | null;
  sequences: CollectionSequenceWithUser[];
}

const initialState: CollectionSequenceInitialState = {
  loadingList: [],
  error: null,
  sequences: [],
};

export const collectionSequenceSlice = createSlice({
  name: 'collectionSequences',
  initialState,
  reducers: {
    resetCollectionSequenceRootState: () => initialState,
  },
  extraReducers(builder) {
    getSupplierCollectionSequencesExtraReducer(builder);
    createCollectionSequenceExtraReducer(builder);
    updateCollectionSequenceExtraReducer(builder);
    deleteCollectionSequenceExtraReducer(builder);
  },
});

export const { resetCollectionSequenceRootState } = collectionSequenceSlice.actions;
